module.exports = __webpack_public_path__ + "img/2025-04-12c_2.8e843156.jpg";